import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DemoSettingsComponent } from './demo-settings/demo-settings.component';

const routes: Routes = [
  {
    path: 'demo-settings',
    component: DemoSettingsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DemoSettingsRoutingModule {}
